module.exports = __webpack_public_path__ + "static/media/film-alt.592482c1.svg";